import React from 'react';
export default class NotificationsDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {open: false };
    this.toggle = this.toggle.bind(this);
    this.markAllRead = this.markAllRead.bind(this);
  }

  componentDidMount() {
    this.loadNotifications();
    setInterval(this.loadLogs, 30000);
  }

  componentDidUpdate() {
  }

  loadNotifications() {
    var self = this;
    $.get(this.props.source, function(result) {
      this.setState({
        notifications: result
      });
    }.bind(this));
  }

  markAllRead() {
    var thisstate = this;
    fetch('/api/v1/notifications/mark_all_read')
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
      	thisstate.setState({
          notifications: data
        });
      })
  }

  toggle() {
    this.setState({ open: !this.state.open });
  }

  toggleClosed() {
    this.setState({ open: false });
  }

  render() {
    var notifications = this.state.notifications || [];

    var menuClasses = "open notification-menu";
    if(!this.state.open) menuClasses += ' hidden';

    var unreadMessages = _.some(notifications, function(o) {
      return !o.read_at;
    });
    var unreadAltertClass = "";
    if(unreadMessages) unreadAltertClass += 'navbar-new';
    console.log("dropdown render");
    console.log(notifications);
    return (
      <div style={{color: '#93a4aa', cursor: 'pointer'}} onClick={this.toggle}>
        <span className="ss-notifications"></span>
        <span className="hidden-lg">Messages</span>
        <span style={{marginTop: '10px'}}className={unreadAltertClass}></span>

        <div className={menuClasses} style={{display: this.state.open ? 'block' : 'none'}}>
          <div className="arrow top"></div>
          <div className="notifications">

            {notifications.map(function(n){
              var rowClasses = "notification";
              if(n.read_at) rowClasses += ' read';

              return <div key={n.id+"-not"} className={rowClasses}>
                <span className="notification-created-at" alt={n.created_at}>{n.time_ago}</span>
                  <a href={n.target_url} className="title">{n.case_id} {n.title}</a>
                  <span className="description">{n.message}</span>
                </div>
            })}

          </div>

          <div className="actionContainer" onClick={this.markAllRead}>
            {I18n.components.notifications_dropdown.mark_all_as_read}
          </div>
        </div>
      </div>
    );
  }
}
